import { toCountryCode } from './to-country-code';

export function normalizeAddress(address: any): any {
  if (!address) { return null; }
  const { country, postalCode, streetName, city, number, state, complement, neighborhood, formattedAddress, coords } = address;

  return {
    countryCode: toCountryCode(country),
    streetName,
    postalCode,
    city,
    number,
    state,
    complement,
    neighborhood,
    formattedAddress,
    coords: coords ? {
      latitude: coords.latitude,
      longitude: coords.longitude
    } : null
  };
}
